import React, { useState } from 'react'
import { Tooltip, IconButton, Dialog } from '@material-ui/core'
import DialogView from '../../../Dialogos/DialogView'
import EditIcon from '@material-ui/icons/Edit'
import EdicionDetalleCarga from './EdicionDetalleCarga'
import { connect } from 'react-redux'
import { actualizarDetalleCarga } from '../../actions/TablaCargaBuquesActions'

function EditarCarga (props) {
  const { data, actualizarDetalleCarga } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  const handleUpdate = () => {
    actualizarDetalleCarga()
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleClose}
          confirmCallback={handleUpdate}
          title='Modificar detalle de carga'
          content={<EdicionDetalleCarga data={data} />}
        />
      </Dialog>
      <Tooltip title={'Editar'}>
        <IconButton onClick={handleOpen} style={{ outline: 'none' }}>
          <EditIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}

const mapActionsToProps = {
  actualizarDetalleCarga
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(EditarCarga)
